@if (open) {
<div class="modal-backdrop fade show"></div>
<div class="modal fade show detail-modal" tabindex="-1" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        @if (isCreateMode()) {
        <h2 class="modal-title">{{ 'pages.licenses.modal.create-title' | translate }}</h2>
        } @else {
        <h2 class="modal-title">{{ 'pages.licenses.modal.edit-title' | translate }}</h2>
        }

        <button class="btn-close" type="button" (click)="closeDetailModal()"></button>
      </div>

      <form class="modal-body form-grid" [formGroup]="form" (ngSubmit)="save()">
        @if (preselectedAccountId === null) {
        <div class="field-block">
          <label class="form-label" for="license-account">{{ 'pages.licenses.fields.account' | translate }}</label>
          <select class="form-select" [disabled]="saving() || deleting() || (isCreateMode() && preselectedAccountId !== null)" id="license-account" [value]="selectedAccountId() ?? ''" (change)="onAccountSelectionChange($event)">
            <option value="">{{ 'pages.licenses.accounts.select-placeholder' | translate }}</option>
            @for (account of availableAccounts(); track account.id ?? account.name) {
            <option [value]="account.id ?? ''">{{ account.name }}</option>
            }
          </select>
        </div>
        }

        <div class="field-block">
          <label class="form-label" for="license-application">{{ 'pages.licenses.fields.application' | translate }}</label>
          <select class="form-select" [disabled]="saving() || deleting()" id="license-application" [value]="selectedApplicationId() ?? ''" (change)="onApplicationSelectionChange($event)">
            <option value="">{{ 'pages.licenses.applications.select-placeholder' | translate }}</option>
            @for (application of availableApplications(); track application.id ?? application.code) {
            <option [value]="application.id ?? ''">{{ application.code }} - {{ application.name }}</option>
            }
          </select>
        </div>

        <app-date-block [invalid]="isInvalid('activeFrom')" controlId="active-from" controlName="activeFrom"
          labelKey="pages.licenses.fields.active-from">
          @if (hasError('activeFrom', 'required') && isInvalid('activeFrom')) {
          <div class="invalid-feedback d-block">{{ 'pages.licenses.validation.active-from-required' | translate }}</div>
          }
        </app-date-block>

        <app-date-block [defaultHour]="23" [defaultMinute]="59" [invalid]="isInvalid('activeTo') || isDateRangeInvalid()"
          controlId="active-to" controlName="activeTo" labelKey="pages.licenses.fields.active-to">
          @if (hasError('activeTo', 'required') && isInvalid('activeTo')) {
          <div class="invalid-feedback d-block">{{ 'pages.licenses.validation.active-to-required' | translate }}</div>
          }
          @if (isDateRangeInvalid()) {
          <div class="invalid-feedback d-block">{{ 'pages.licenses.validation.active-to-min-one-day' | translate }}</div>
          }
        </app-date-block>

        <app-input-block [fullWidth]="true" [invalid]="isInvalid('notes')" controlId="notes" controlName="notes" labelKey="pages.licenses.fields.notes">
          @if (hasError('notes', 'required') && isInvalid('notes')) {
          <div class="invalid-feedback">{{ 'pages.licenses.validation.notes-required' | translate }}</div>
          }
          @if (hasError('notes', 'maxlength') && isInvalid('notes')) {
          <div class="invalid-feedback">{{ 'pages.licenses.validation.notes-maxlength' | translate }}</div>
          }
        </app-input-block>

        @if (isEditMode()) {
        <app-input-block [readonly]="true" [value]="selectedCreatedAt()" controlId="created-at" labelKey="pages.licenses.fields.created-at" />

        <app-input-block [readonly]="true" [value]="selectedUpdatedAt()" controlId="updated-at" labelKey="pages.licenses.fields.updated-at" />
        }
      </form>

      <div class="modal-footer">
        @if (isEditMode()) {
        <button class="btn btn-light btn-danger-soft me-auto" [disabled]="saving() || deleting()" type="button" (click)="requestDelete()">
          <i class="fa-solid fa-trash" aria-hidden="true"></i>
          {{ 'pages.licenses.actions.delete' | translate }}
        </button>
        }

        <button class="btn btn-light" [disabled]="saving() || deleting()" type="button" (click)="closeDetailModal()">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          {{ 'pages.licenses.actions.cancel' | translate }}
        </button>

        <button class="btn btn-primary" [disabled]="saving() || deleting()" type="button" (click)="save()">
          <i class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
          {{ 'pages.licenses.actions.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
}
